import { Component, OnInit, isDevMode } from '@angular/core';
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from '../../../../services/helpers.service';
import { PartnerService } from '../../../../services/partner.service';
import { TechnicianService } from '../../../../services/technician.service';
import { CountriesService } from '../../../../services/countries.service';
import { AppConfig } from '../../../../app.config';
import { ConfirmationService } from 'primeng/api';
import { DazzleIconComponent } from '../../../shared/dazzle-icons/dazzle-icon.component';
import moment from 'moment';
import { ServiceRequestService } from '../../../../services/servicerequest.service';

@Component({
  selector: 'app-other-settings',
  templateUrl: './other-settings.component.html',
  styleUrls: ['./other-settings.component.scss'],
  providers: [MessageService],
})
export class OtherSettingsComponent implements OnInit {
  public partnerId: any;
  public partner: any = {};
  public ShopForm: FormGroup;
  public busy: boolean = false;
  public workflowItems: any = [
    { label: 'Select a workflow', value: 0 },
    { label: 'Hubtiger Job Card Workflow', value: 1 },
    { label: 'Manual Jobcard Workflow', value: 2 },
    { label: 'Hubtiger QA Sheet Only', value: 3 },
  ];
  public units: any = this.appConfig.getUnits();
  public countries = []; //this.appConfig.getSupportedCountries();
  public fallBackImage = '';
  public isDev: boolean = false;
  public technicians = [];
  public INeedHelpColor = '';
  public externalIntegrationOptions: any = [];
  public defaultQuoteTabOptions: any = [
    {
      value: 'JOBCARD',
      label: this.translate.instant(
        'bikeshop.modal.update_job_card.tab.jobcard',
      ),
    },
    {
      value: 'QUOTE',
      label: this.translate.instant('bikeshop.modal.update_job_card.tab.quote'),
    },
  ];

  public partnerCountry: any;
  public timeOptions: any;
  public disableAddBays: boolean = false;
  public disableAddTags: boolean = false;
  public isAdmin: boolean = false;
  public isWorkshopManager: boolean = false;
  constructor(
    private appConfig: AppConfig,
    private fb: FormBuilder,
    private helpersService: HelpersService,
    private partnerService: PartnerService,
    public messageService: MessageService,
    private countriesService: CountriesService,
    private translate: TranslateService,
    private confirmationService: ConfirmationService,
    private technicianService: TechnicianService,
    private serviceRequestService: ServiceRequestService,
  ) {
    this.partnerId = this.helpersService.getPartnerId();
    this.partner = this.helpersService.getPartnerData();
    this.partnerCountry = this.helpersService.getCountryData();
    this.isDev = isDevMode();
    this.isAdmin = this.helpersService.isAdminUser();
    this.isWorkshopManager = this.helpersService.isWorkshopManagerUser();
    console.log(this.partnerCountry);

    // Generate options for 1AM-11PM (skips midnight)
    this.timeOptions = Array.from({ length: 23 }, (_, i) => ({
      value: i + 1,
      label: this.formatHourForDisplay(i + 1)
    }));
  }

  ngOnInit() {
    this.getPartnerData();
    this.countriesService.getAllCountries().subscribe((countries) => {
      this.countries = countries.map((x) => {
        return { ...x, label: x.country, value: x.code };
      });
    });
    this.getTechncians();
    this.getBays();
    this.getTags();
  }

  getExternalIntegrationOptions() {
    this.partnerService
      .getExternalIntegrationOptions(this.helpersService.getPartnerId())
      .subscribe((options) => {
        this.externalIntegrationOptions = options.map((option) => {
          var existingOption =
            this.partner.ExternalProductIntegrationsPartnerLinks.filter((x) => {
              return (
                x.ExternalProductPartnerID === option.ExternalProductPartnerID
              );
            }).pop();
          return {
            ...existingOption,
            Name: option.Name,
            ExternalProductPartnerID: option.ExternalProductPartnerID,
            PartnerID: this.helpersService.getPartnerId(),
            Enabled: existingOption !== undefined,
          };
        });
      });
  }

  getTechncians() {
    this.partnerService
      .getPartnerTechnicians(this.helpersService.getPartnerId())
      .subscribe((technicians) => {
        this.technicians = technicians.filter((x) => {
          return x.IsActive === true;
        });
      });
  }

  saveTechnician(technician) {
    this.technicianService.updateTechnician(technician).subscribe((res) => { });
  }

  getPartnerData() {
    this.partnerService
      .getPartnerDetail(this.helpersService.getPartnerId())
      .subscribe((partner) => {
        this.partner = partner;

        this.getExternalIntegrationOptions();
        if (!this.partner.PartnerImage) {
          this.fallBackImage =
            'https://' +
            (isDevMode() ? 'hubtigerdev' : 'hubtiger') +
            '.blob.core.windows.net/partners/partnerlogo_' +
            this.partnerId +
            '.jpeg';
          this.partnerService.testURL(this.fallBackImage).subscribe(
            (res) => { },
            (err) => {
              this.fallBackImage = null;
            },
          );
        }
        if (
          this.partner.INeedHelpColor &&
          this.partner.INeedHelpColor.length > 0
        ) {
          this.INeedHelpColor = this.partner.INeedHelpColor;

          this.partner.CustomLabelOne = partner.Statuses.find(x => x.StatusID == 21).Label.trim();
          this.partner.CustomLabelTwo = partner.Statuses.find(x => x.StatusID == 22).Label.trim();
          this.partner.CustomLabelThree = partner.Statuses.find(x => x.StatusID == 23).Label.trim();
          this.partner.CustomLabelFour = partner.Statuses.find(x => x.StatusID == 24).Label.trim();
          this.partner.CustomLabelFive = partner.Statuses.find(x => x.StatusID == 27).Label.trim();
          this.partner.CustomLabelSix = partner.Statuses.find(x => x.StatusID == 28).Label.trim();
          this.partner.CustomLabelSeven = partner.Statuses.find(x => x.StatusID == 29).Label.trim();
          this.partner.CustomLabelEight = partner.Statuses.find(x => x.StatusID == 32).Label.trim();
          this.partner.CustomLabelNine = partner.Statuses.find(x => x.StatusID == 33).Label.trim();

          this.partner.CustomColourOne = partner.Statuses.find(x => x.StatusID == 21).Colour;
          this.partner.CustomColourTwo = partner.Statuses.find(x => x.StatusID == 22).Colour;
          this.partner.CustomColourThree = partner.Statuses.find(x => x.StatusID == 23).Colour;
          this.partner.CustomColourFour = partner.Statuses.find(x => x.StatusID == 24).Colour;
          this.partner.CustomColourFive = partner.Statuses.find(x => x.StatusID == 27).Colour;
          this.partner.CustomColourSix = partner.Statuses.find(x => x.StatusID == 28).Colour;
          this.partner.CustomColourSeven = partner.Statuses.find(x => x.StatusID == 29).Colour;
          this.partner.CustomColourEight = partner.Statuses.find(x => x.StatusID == 32).Colour;
          this.partner.CustomColourNine = partner.Statuses.find(x => x.StatusID == 33).Colour;

        }

        this.setupValidation();
      });
  }

  setupValidation() {
    this.ShopForm = this.fb.group({
      SendInsightDailyEmail: new FormControl(
        this.partner.SendInsightDailyEmail || false,
        Validators.nullValidator,
      ),
      ServiceInsightEmailAddresses: new FormControl(
        this.partner.ServiceInsightEmailAddresses || '',
        Validators.nullValidator,
      ),
      SendFinanceInsightEmail: new FormControl(
        this.partner.SendFinanceInsightEmail || false,
        Validators.nullValidator,
      ),
      ServiceFinanceInsightEmailAddresses: new FormControl(
        this.partner.ServiceFinanceInsightEmailAddresses || '',
        Validators.nullValidator,
      ),

      SendNotificationOnBooking: new FormControl(
        this.partner.SendNotificationOnBooking || false,
        Validators.nullValidator,
      ),
      ReminderHoursBeforeService: new FormControl(
        this.partner.ReminderHoursBeforeService,
        [Validators.required, Validators.max(72), Validators.min(12)],
      ),
      ServiceFollowUpReminderMonths: new FormControl(
        this.partner.ServiceFollowUpReminderMonths,
        [Validators.required, Validators.max(12), Validators.min(1)],
      ),
      OtherServiceFollowUpReminderMonths: new FormControl(
        this.partner.OtherServiceFollowUpReminderMonths,
        [Validators.required, Validators.max(24), Validators.min(6)],
      ),

      BikeNotCollectedFollowUpDays: new FormControl(
        this.partner.BikeNotCollectedFollowUpDays,
        [Validators.required, Validators.max(365), Validators.min(0)],
      ),

      BikeNotCollectedFollowUpReminderDays: new FormControl(
        this.partner.BikeNotCollectedFollowUpReminderDays,
        [Validators.required, Validators.max(365), Validators.min(0)],
      ),

      DeliveryNotBookedFollowUpDays: new FormControl(
        this.partner.DeliveryNotBookedFollowUpDays,
        [Validators.required, Validators.max(365), Validators.min(0)],
      ),

      DeliveryNotBookedReminderFollowUpDays: new FormControl(
        this.partner.DeliveryNotBookedReminderFollowUpDays,
        [Validators.required, Validators.max(365), Validators.min(0)],
      ),
      PostServiceFollowUpDays: new FormControl(
        this.partner.PostServiceFollowUpDays,
        [Validators.required, Validators.max(30), Validators.min(1)],
      ),
      CollectionServiceBufferDays: new FormControl(
        this.partner.CollectionServiceBufferDays,
        [Validators.required, Validators.max(14), Validators.min(1)],
      ),
      BikeIsHereDefault: new FormControl(
        this.partner.BikeIsHereDefault || false,
        Validators.nullValidator,
      ),
      Print_ShowLogo: new FormControl(
        this.partner.Print_ShowLogo || false,
        Validators.nullValidator,
      ),
      Print_ShowChecklist: new FormControl(
        this.partner.Print_ShowChecklist || false,
        Validators.nullValidator,
      ),
      Print_ShowLineItemBarcode: new FormControl(
        this.partner.Print_ShowLineItemBarcode || false,
        Validators.nullValidator,
      ),
      Print_ShowOnlyPreServiceCheck: new FormControl(
        this.partner.Print_ShowOnlyPreServiceCheck || false,
        Validators.nullValidator,
      ),
      Print_ShowQuote: new FormControl(
        this.partner.Print_ShowQuote || false,
        Validators.nullValidator,
      ),
      PrintJobcardQRCode: new FormControl(
        this.partner.PrintJobcardQRCode || false,
        Validators.nullValidator,
      ),
      ShowJobCardBarcode: new FormControl(
        this.partner.ShowJobCardBarcode || false,
        Validators.nullValidator,
      ),
      ShowJobCardStatus: new FormControl(
        this.partner.ShowJobCardStatus || false,
        Validators.nullValidator,
      ),
      ShowLineItemNotesOnJobcard: new FormControl(
        this.partner.ShowLineItemNotesOnJobcard || false,
        Validators.nullValidator,
      ),
      ShowLabourGoals: new FormControl(
        this.partner.ShowLabourGoals || false,
        Validators.nullValidator,
      ),
      ShowLabourTotalsCalendar: new FormControl(
        this.partner.ShowLabourTotalsCalendar || false,
        Validators.nullValidator,
      ),
      ShowWorkshopTotalsCalendar: new FormControl(
        this.partner.ShowWorkshopTotalsCalendar || false,
        Validators.nullValidator,
      ),
      ShowINeedHelp: new FormControl(
        this.partner.ShowINeedHelp || false,
        Validators.nullValidator,
      ),
      ShowTechnicianLegendCalendar: new FormControl(
        this.partner.ShowTechnicianLegendCalendar || false,
        Validators.nullValidator,
      ),
      AllowExactMatchingOnQuote: new FormControl(
        this.partner.AllowExactMatchingOnQuote || false,
        Validators.nullValidator,
      ),
      AllowMultipleQuoteOptions: new FormControl(
        this.partner.AllowMultipleQuoteOptions || false,
        Validators.nullValidator,
      ),
      AllowQuoteToUpdateServiceTypes: new FormControl(
        this.partner.AllowQuoteToUpdateServiceTypes || false,
        Validators.nullValidator,
      ),
      INeedHelpLabel: new FormControl(
        this.partner.INeedHelpLabel || '',
        Validators.nullValidator,
      ),
      PickupLabel: new FormControl(
        this.partner.PickupLabel || '',
        Validators.nullValidator,
      ),
      BookedInLabel: new FormControl(
        this.partner.BookedInLabel || '',
        Validators.nullValidator,
      ),
      FittingsBookedInLabel: new FormControl(
        this.partner.FittingsBookedInLabel || '',
        Validators.nullValidator,
      ),
      WaitingForWorkLabel: new FormControl(
        this.partner.WaitingForWorkLabel || '',
        Validators.nullValidator,
      ),
      WorkingOnLabel: new FormControl(
        this.partner.WorkingOnLabel || '',
        Validators.nullValidator,
      ),
      WarrantyLabel: new FormControl(
        this.partner.WarrantyLabel || '',
        Validators.nullValidator,
      ),
      WaitingForPartsLabel: new FormControl(
        this.partner.WaitingForPartsLabel || '',
        Validators.nullValidator,
      ),
      WaitingForClientLabel: new FormControl(
        this.partner.WaitingForClientLabel || '',
        Validators.nullValidator,
      ),
      FittingCompleteLabel: new FormControl(
        this.partner.FittingCompleteLabel || '',
        Validators.nullValidator,
      ),
      CompletedLabel: new FormControl(
        this.partner.CompletedLabel || '',
        Validators.nullValidator,
      ),
      CollectedLabel: new FormControl(
        this.partner.CollectedLabel || '',
        Validators.nullValidator,
      ),
      DeliveryLabel: new FormControl(
        this.partner.DeliveryLabel || '',
        Validators.nullValidator,
      ),
      CancelledLabel: new FormControl(
        this.partner.CancelledLabel || '',
        Validators.nullValidator,
      ),
      OpenPrintOnNewJob: new FormControl(
        this.partner.OpenPrintOnNewJob || false,
        Validators.nullValidator,
      ),
      AllowThirdPartyPartnersOnJobCard: new FormControl(
        this.partner.AllowThirdPartyPartnersOnJobCard || false,
        Validators.nullValidator,
      ),
      POSCustomURL: new FormControl(
        this.partner.POSCustomURL || '',
        Validators.nullValidator,
      ),
      SendDailySummaryReport: new FormControl(
        this.partner.SendDailySummaryReport || false,
        Validators.nullValidator,
      ),
      DailySummaryReportRecipients: new FormControl(
        this.partner.DailySummaryReportRecipients || '',
        Validators.nullValidator,
      ),
      RequestOrder: new FormControl(
        this.partner.RequestOrder || false,
        Validators.nullValidator,
      ),
      ManageStock: new FormControl(
        this.partner.ManageStock || false,
        Validators.nullValidator,
      ),
      AddStockBackAtSendToPOS: new FormControl(
        this.partner.AddStockBackAtSendToPOS || false,
        Validators.nullValidator,
      ),
      EnableInventoryManagementCorrectService: new FormControl(
        this.partner.EnableInventoryManagementCorrectService || false,
        Validators.nullValidator,
      ),
      AllowItemTransfers: new FormControl(
        this.partner.AllowItemTransfers || false,
        Validators.nullValidator,
      ),
      ShowOriginalDateOnCalendar: new FormControl(
        this.partner.ShowOriginalDateOnCalendar || false,
        Validators.nullValidator,
      ),
      DefaultDayViewTimeInterval: new FormControl(
        this.partner.DefaultDayViewTimeInterval || '00:15:00',
        Validators.nullValidator,
      ),
      DisableAutoCollect: new FormControl(
        this.partner.DisableAutoCollect || false,
        Validators.nullValidator,
      ),
      LockJobCardOnCollection: new FormControl(
        this.partner.LockJobCardOnCollection || false,
        Validators.nullValidator,
      ),
      PickupsColor: new FormControl(
        this.partner.PickupsColor || '#F18BC9',
        Validators.nullValidator,
      ),
      BookedInColor: new FormControl(
        this.partner.BookedInColor || '#898fa1',
        Validators.nullValidator,
      ),
      WaitingForWorkColor: new FormControl(
        this.partner.WaitingForWorkColor || '#9fd661',
        Validators.nullValidator,
      ),
      WaitingForClientColor: new FormControl(
        this.partner.WaitingForClientColor || '#ff9752',
        Validators.nullValidator,
      ),
      WaitingForPartsColor: new FormControl(
        this.partner.WaitingForPartsColor || '#ffb837',
        Validators.nullValidator,
      ),
      WarrantyColor: new FormControl(
        this.partner.WarrantyColor || '#ffe460',
        Validators.nullValidator,
      ),
      WorkingOnColor: new FormControl(
        this.partner.WorkingOnColor || '#19c89a',
        Validators.nullValidator,
      ),
      BikeReadyColor: new FormControl(
        this.partner.BikeReadyColor || '#32c5ff',
        Validators.nullValidator,
      ),
      CollectedColor: new FormControl(
        this.partner.CollectedColor || '#196bc7',
        Validators.nullValidator,
      ),
      DeliveryColor: new FormControl(
        this.partner.DeliveryColor || '#ac8ff0',
        Validators.nullValidator,
      ),
      SendNotificationOnFittingBooking: new FormControl(
        this.partner.SendNotificationOnFittingBooking || false,
        Validators.nullValidator,
      ),
      FittingNotificationsAddresses: new FormControl(
        this.partner.FittingNotificationsAddresses || '',
        Validators.nullValidator,
      ),
      ServiceNotificationsAddresses: new FormControl(
        this.partner.ServiceNotificationsAddresses || '',
        Validators.nullValidator,
      ),
      SendNotificationOnRental: new FormControl(
        this.partner.SendNotificationOnRental || false,
        Validators.nullValidator,
      ),
      RentalNotificationsAddresses: new FormControl(
        this.partner.RentalNotificationsAddresses || '',
        Validators.nullValidator,
      ),
      PrintOutQRImageURL: new FormControl(
        this.partner.PrintOutQRImageURL || '',
        Validators.nullValidator,
      ),
      PrintOutTerms: new FormControl(
        this.partner.PrintOutTerms || '',
        Validators.nullValidator,
      ),
      ShowBikeTypeOnCalendar: new FormControl(
        this.partner.ShowBikeTypeOnCalendar || false,
        Validators.nullValidator,
      ),
      CreatedByOverrideOnBooking: new FormControl(
        this.partner.CreatedByOverrideOnBooking || false,
        Validators.nullValidator,
      ),
      OpenTabOnScheduleAndOpen: new FormControl(
        this.partner.OpenTabOnScheduleAndOpen || 'JOBCARD',
        Validators.nullValidator,
      ),
      UseLineItemNotesFromPOS: new FormControl(
        this.partner.UseLineItemNotesFromPOS || false,
        Validators.nullValidator,
      ),
      EnableDailyShoprideSummary: new FormControl(
        this.partner.EnableDailyShoprideSummary || false,
        Validators.nullValidator,
      ),
      DailyShoprideSummaryReminderTime: new FormControl(
        this.partner.DailyShoprideSummaryReminderTime || 8, // Default to 8 AM if null
        [Validators.required, Validators.min(1), Validators.max(23)]
      ),
      UseNewJobCard: new FormControl(
        this.partner.UseNewJobCard || false,
        Validators.nullValidator,
      ),
      EnableWorkshopTimer: new FormControl(
        this.partner.EnableWorkshopTimer || false,
        Validators.nullValidator,
      ),
      CustomLabelOne: new FormControl(
        this.partner.CustomLabelOne || "",
        Validators.nullValidator,
      ),
      CustomLabelTwo: new FormControl(
        this.partner.CustomLabelTwo || "",
        Validators.nullValidator,
      ),
      CustomLabelThree: new FormControl(
        this.partner.CustomLabelThree || "",
        Validators.nullValidator,
      ),
      CustomLabelFour: new FormControl(
        this.partner.CustomLabelFour || "",
        Validators.nullValidator,
      ),
      CustomLabelFive: new FormControl(
        this.partner.CustomLabelFive || "",
        Validators.nullValidator,
      ),
      CustomLabelSix: new FormControl(
        this.partner.CustomLabelSix || "",
        Validators.nullValidator,
      ),
      CustomLabelSeven: new FormControl(
        this.partner.CustomLabelSeven || "",
        Validators.nullValidator,
      ),
      CustomLabelEight: new FormControl(
        this.partner.CustomLabelEight || "",
        Validators.nullValidator,
      ),
      CustomLabelNine: new FormControl(
        this.partner.CustomLabelNine || "",
        Validators.nullValidator,
      ),
      CustomColourOne: new FormControl(
        this.partner.CustomColourOne || "",
        Validators.nullValidator,
      ),
      CustomColourTwo: new FormControl(
        this.partner.CustomColourTwo || "",
        Validators.nullValidator,
      ),
      CustomColourThree: new FormControl(
        this.partner.CustomColourThree || "",
        Validators.nullValidator,
      ),
      CustomColourFour: new FormControl(
        this.partner.CustomColourFour || "",
        Validators.nullValidator,
      ),
      CustomColourFive: new FormControl(
        this.partner.CustomColourFive || "",
        Validators.nullValidator,
      ),
      CustomColourSix: new FormControl(
        this.partner.CustomColourSix || "",
        Validators.nullValidator,
      ),
      CustomColourSeven: new FormControl(
        this.partner.CustomColourSeven || "",
        Validators.nullValidator,
      ),
      CustomColourEight: new FormControl(
        this.partner.CustomColourEight || "",
        Validators.nullValidator,
      ),
      CustomColourNine: new FormControl(
        this.partner.CustomColourNine || "",
        Validators.nullValidator,
      )
    });

    if (this.ShopForm.controls['ShowLabourGoals'].value === true) {
      this.ShopForm.controls['ShowLabourTotalsCalendar'].disable();
    }
    this.setINeedHelpState();
    this.setDailySummaryReportState();
  }

  savePartner(partner) {
    var iNeedHelpLabel = this.helpersService.getPartnerData().INeedHelpLabel;
    var RequestOrder = this.helpersService.getPartnerData().RequestOrder;
    var PrintJobcardQRCode =
      this.helpersService.getPartnerData().PrintJobcardQRCode;
    var ShowJobCardBarcode =
      this.helpersService.getPartnerData().ShowJobCardBarcode;
    var ShowLineItemNotesOnJobcard =
      this.helpersService.getPartnerData().ShowLineItemNotesOnJobcard;

    this.busy = true;
    let update = {
      ...this.partner,
      ...partner,
    };
    if (this.INeedHelpColor && this.INeedHelpColor.length > 0) {
      update.INeedHelpColor = this.INeedHelpColor;
    }

    update.ExternalProductIntegrationsPartnerLinks = !update.RequestOrder
      ? []
      : this.externalIntegrationOptions
        .filter((x) => {
          return x.Enabled;
        })
        .map((option) => {
          return {
            ID: option.ID || 0,
            ExternalProductPartnerID: option.ExternalProductPartnerID,
            PartnerID: option.PartnerID,
          };
        });

    update.Statuses = this.helpersService.getPartnerData().Statuses;

    console.log(this.ShopForm);

    update.Statuses.find(x => x.StatusID == 21).Label = this.ShopForm.value.CustomLabelOne.trim();
    update.Statuses.find(x => x.StatusID == 22).Label = this.ShopForm.value.CustomLabelTwo.trim();
    update.Statuses.find(x => x.StatusID == 23).Label = this.ShopForm.value.CustomLabelThree.trim();
    update.Statuses.find(x => x.StatusID == 24).Label = this.ShopForm.value.CustomLabelFour.trim();
    update.Statuses.find(x => x.StatusID == 27).Label = this.ShopForm.value.CustomLabelFive.trim();
    update.Statuses.find(x => x.StatusID == 28).Label = this.ShopForm.value.CustomLabelSix.trim();
    update.Statuses.find(x => x.StatusID == 29).Label = this.ShopForm.value.CustomLabelSeven.trim();
    update.Statuses.find(x => x.StatusID == 32).Label = this.ShopForm.value.CustomLabelEight.trim();
    update.Statuses.find(x => x.StatusID == 33).Label = this.ShopForm.value.CustomLabelNine.trim();

    update.Statuses.find(x => x.StatusID == 21).Colour = this.ShopForm.value.CustomColourOne;
    update.Statuses.find(x => x.StatusID == 22).Colour = this.ShopForm.value.CustomColourTwo;
    update.Statuses.find(x => x.StatusID == 23).Colour = this.ShopForm.value.CustomColourThree;
    update.Statuses.find(x => x.StatusID == 24).Colour = this.ShopForm.value.CustomColourFour;
    update.Statuses.find(x => x.StatusID == 27).Colour = this.ShopForm.value.CustomColourFive;
    update.Statuses.find(x => x.StatusID == 28).Colour = this.ShopForm.value.CustomColourSix;
    update.Statuses.find(x => x.StatusID == 29).Colour = this.ShopForm.value.CustomColourSeven;
    update.Statuses.find(x => x.StatusID == 32).Colour = this.ShopForm.value.CustomColourEight;
    update.Statuses.find(x => x.StatusID == 33).Colour = this.ShopForm.value.CustomColourNine;

    update.Statuses.find(x => x.StatusID == 31).Label = this.ShopForm.value.INeedHelpLabel;
    update.Statuses.find(x => x.StatusID == 31).Colour = this.ShopForm.value.INeedHelpColor;

    update.Statuses.find(x => x.StatusID == 5).Label = this.ShopForm.value.PickupLabel.trim();
    update.Statuses.find(x => x.StatusID == 5).Colour = this.ShopForm.value.PickupsColor;
    update.Statuses.find(x => x.StatusID == 10).Label = this.ShopForm.value.BookedInLabel.trim();
    update.Statuses.find(x => x.StatusID == 10).Colour = this.ShopForm.value.BookedInColor;
    update.Statuses.find(x => x.StatusID == 15).Label = this.ShopForm.value.BookedInLabel.trim();
    update.Statuses.find(x => x.StatusID == 15).Colour = this.ShopForm.value.BookedInColor;
    update.Statuses.find(x => x.StatusID == 20).Label = this.ShopForm.value.WaitingForWorkLabel.trim();
    update.Statuses.find(x => x.StatusID == 20).Colour = this.ShopForm.value.WaitingForWorkColor;
    update.Statuses.find(x => x.StatusID == 25).Label = this.ShopForm.value.WorkingOnLabel.trim();
    update.Statuses.find(x => x.StatusID == 25).Colour = this.ShopForm.value.WorkingOnColor;
    update.Statuses.find(x => x.StatusID == 26).Label = this.ShopForm.value.WarrantyLabel.trim();
    update.Statuses.find(x => x.StatusID == 26).Colour = this.ShopForm.value.WarrantyColor;
    update.Statuses.find(x => x.StatusID == 35).Label = this.ShopForm.value.WaitingForPartsLabel.trim();
    update.Statuses.find(x => x.StatusID == 35).Colour = this.ShopForm.value.WaitingForPartsColor;
    update.Statuses.find(x => x.StatusID == 30).Label = this.ShopForm.value.WaitingForClientLabel.trim();
    update.Statuses.find(x => x.StatusID == 30).Colour = this.ShopForm.value.WaitingForClientColor;
    update.Statuses.find(x => x.StatusID == 40).Label = this.ShopForm.value.CompletedLabel.trim();
    update.Statuses.find(x => x.StatusID == 40).Colour = this.ShopForm.value.BikeReadyColor;
    update.Statuses.find(x => x.StatusID == 45).Label = this.ShopForm.value.CompletedLabel.trim();
    update.Statuses.find(x => x.StatusID == 45).Colour = this.ShopForm.value.BikeReadyColor;
    update.Statuses.find(x => x.StatusID == 50).Label = this.ShopForm.value.CollectedLabel.trim();
    update.Statuses.find(x => x.StatusID == 50).Colour = this.ShopForm.value.CollectedColor;
    update.Statuses.find(x => x.StatusID == 55).Label = this.ShopForm.value.DeliveryLabel.trim();
    update.Statuses.find(x => x.StatusID == 55).Colour = this.ShopForm.value.DeliveryColor;
    update.Statuses.find(x => x.StatusID == 100).Label = this.ShopForm.value.CancelledLabel.trim();

    console.log(update);


    this.partnerService.savePartnerDetail(update).subscribe((partner) => {
      this.busy = false;
      this.messageService.add({
        life: 5000,
        detail: this.translate.instant(
          'bikeshop.shop_profile.message_profile_updates',
        ),
      });

      this.partnerService.getPartnerDetail(this.helpersService.getPartnerId()).subscribe((updatePartner) => {
        this.helpersService.savePartnerData(updatePartner);
      });

      if (this.ShopForm.controls['ShowLabourGoals'].value) {
        this.technicians.forEach((technician) => {
          this.saveTechnician(technician);
        });
      }
      try {
        if (partner.INeedHelpColor && partner.INeedHelpColor.length > 0) {
          var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(partner.INeedHelpColor,);
          document.documentElement.style.setProperty('--i-need-help-var', partner.INeedHelpColor,);
          document.documentElement.style.setProperty('--i-need-help-light-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),
          );
        }
      } catch { }
      if (partner.PickupsColor && partner.PickupsColor.length > 0) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(partner.PickupsColor,);
        document.documentElement.style.setProperty('--pick-up-color-var', partner.PickupsColor,);
        document.documentElement.style.setProperty('--pick-up-colorlight-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),
        );
      }
      if (partner.BookedInColor && partner.BookedInColor.length > 0) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
          partner.BookedInColor,
        );
        document.documentElement.style.setProperty(
          '--booked-in-color-var',
          partner.BookedInColor,
        );
        document.documentElement.style.setProperty(
          '--booked-in-color-light-var',
          parseInt(result[1], 16) +
          ',' +
          parseInt(result[2], 16) +
          ',' +
          parseInt(result[3], 16),
        );
      }
      if (
        partner.WaitingForWorkColor &&
        partner.WaitingForWorkColor.length > 0
      ) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
          partner.WaitingForWorkColor,
        );
        document.documentElement.style.setProperty(
          '--assigned-to-technician-color-var',
          partner.WaitingForWorkColor,
        );
        document.documentElement.style.setProperty(
          '--assigned-to-technician-color-light-var',
          parseInt(result[1], 16) +
          ',' +
          parseInt(result[2], 16) +
          ',' +
          parseInt(result[3], 16),
        );
      }
      if (
        partner.WaitingForClientColor &&
        partner.WaitingForClientColor.length > 0
      ) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
          partner.WaitingForClientColor,
        );
        document.documentElement.style.setProperty(
          '--waiting-for-client-color-var',
          partner.WaitingForClientColor,
        );
        document.documentElement.style.setProperty(
          '--waiting-for-client-color-light-var',
          parseInt(result[1], 16) +
          ',' +
          parseInt(result[2], 16) +
          ',' +
          parseInt(result[3], 16),
        );
      }
      if (
        partner.WaitingForPartsColor &&
        partner.WaitingForPartsColor.length > 0
      ) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
          partner.WaitingForPartsColor,
        );
        document.documentElement.style.setProperty(
          '--waiting-for-parts-color-var',
          partner.WaitingForPartsColor,
        );
        document.documentElement.style.setProperty(
          '--waiting-for-parts-color-light-var',
          parseInt(result[1], 16) +
          ',' +
          parseInt(result[2], 16) +
          ',' +
          parseInt(result[3], 16),
        );
      }
      if (partner.WarrantyColor && partner.WarrantyColor.length > 0) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
          partner.WarrantyColor,
        );
        document.documentElement.style.setProperty(
          '--warranty-color-var',
          partner.WarrantyColor,
        );
        document.documentElement.style.setProperty(
          '--warranty-color-light-var',
          parseInt(result[1], 16) +
          ',' +
          parseInt(result[2], 16) +
          ',' +
          parseInt(result[3], 16),
        );
      }
      if (partner.WorkingOnColor && partner.WorkingOnColor.length > 0) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
          partner.WorkingOnColor,
        );
        document.documentElement.style.setProperty(
          '--started-working-var',
          partner.WorkingOnColor,
        );
        document.documentElement.style.setProperty(
          '--started-working-light-var',
          parseInt(result[1], 16) +
          ',' +
          parseInt(result[2], 16) +
          ',' +
          parseInt(result[3], 16),
        );
      }
      if (partner.BikeReadyColor && partner.BikeReadyColor.length > 0) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
          partner.BikeReadyColor,
        );
        document.documentElement.style.setProperty(
          '--ready-for-collection-color-var',
          partner.BikeReadyColor,
        );
        document.documentElement.style.setProperty(
          '--ready-for-collection-color-light-var',
          parseInt(result[1], 16) +
          ',' +
          parseInt(result[2], 16) +
          ',' +
          parseInt(result[3], 16),
        );
      }
      if (partner.CollectedColor && partner.CollectedColor.length > 0) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
          partner.CollectedColor,
        );
        document.documentElement.style.setProperty(
          '--collected-color-var',
          partner.CollectedColor,
        );
        document.documentElement.style.setProperty(
          '--collected-color-light-var',
          parseInt(result[1], 16) +
          ',' +
          parseInt(result[2], 16) +
          ',' +
          parseInt(result[3], 16),
        );
      }
      if (partner.DeliveryColor && partner.DeliveryColor.length > 0) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
          partner.DeliveryColor,
        );
        document.documentElement.style.setProperty(
          '--to-drop-off-color-var',
          partner.DeliveryColor,
        );
        document.documentElement.style.setProperty(
          '--to-drop-off-color-light-var',
          parseInt(result[1], 16) +
          ',' +
          parseInt(result[2], 16) +
          ',' +
          parseInt(result[3], 16),
        );
      }

      if (this.partner.CustomColourOne && this.partner.CustomColourOne.length > 0) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.partner.CustomColourOne,);
        document.documentElement.style.setProperty('--custom-colour-one-var', this.partner.CustomColourOne,);
        document.documentElement.style.setProperty('--custom-colour-one-light-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),);
      }
      if (this.partner.CustomColourTwo && this.partner.CustomColourTwo.length > 0) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.partner.CustomColourTwo,);
        document.documentElement.style.setProperty('--custom-colour-two-var', this.partner.CustomColourTwo,);
        document.documentElement.style.setProperty('--custom-colour-two-light-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),);
      }
      if (this.partner.CustomColourThree && this.partner.CustomColourThree.length > 0) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.partner.CustomColourThree,);
        document.documentElement.style.setProperty('--custom-colour-three-var', this.partner.CustomColourThree,);
        document.documentElement.style.setProperty('--custom-colour-three-light-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),);
      }
      if (this.partner.CustomColourFour && this.partner.CustomColourFour.length > 0) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.partner.CustomColourFour,);
        document.documentElement.style.setProperty('--custom-colour-four-var', this.partner.CustomColourFour,);
        document.documentElement.style.setProperty('--custom-colour-four-light-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),);
      }
      if (this.partner.CustomColourFive && this.partner.CustomColourFive.length > 0) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.partner.CustomColourFive,);
        document.documentElement.style.setProperty('--custom-colour-five-var', this.partner.CustomColourFive,);
        document.documentElement.style.setProperty('--custom-colour-five-light-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),);
      }
      if (this.partner.CustomColourSix && this.partner.CustomColourSix.length > 0) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.partner.CustomColourSix,);
        document.documentElement.style.setProperty('--custom-colour-six-var', this.partner.CustomColourSix,);
        document.documentElement.style.setProperty('--custom-colour-six-light-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),);
      }
      if (this.partner.CustomColourSeven && this.partner.CustomColourSeven.length > 0) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.partner.CustomColourSeven,);
        document.documentElement.style.setProperty('--custom-colour-seven-var', this.partner.CustomColourSeven,);
        document.documentElement.style.setProperty('--custom-colour-seven-light-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),);
      }
      if (this.partner.CustomColourEight && this.partner.CustomColourEight.length > 0) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.partner.CustomColourEight,);
        document.documentElement.style.setProperty('--custom-colour-eight-var', this.partner.CustomColourEight,);
        document.documentElement.style.setProperty('--custom-colour-eight-light-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),);
      }
      if (this.partner.CustomColourNine && this.partner.CustomColourNine.length > 0) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.partner.CustomColourNine,);
        document.documentElement.style.setProperty('--custom-colour-nine-var', this.partner.CustomColourNine,);
        document.documentElement.style.setProperty('--custom-colour-nine-light-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),);
      }

      //if (
      //  (iNeedHelpLabel !== partner.INeedHelpLabel && partner.ShowINeedHelp) ||
      //  this.helpersService.getPartnerData().PickupLabel !==
      //  partner.PickupLabel ||
      //  this.helpersService.getPartnerData().BookedInLabel !==
      //  partner.BookedInLabel ||
      //  this.helpersService.getPartnerData().WaitingForWorkLabel !==
      //  partner.WaitingForWorkLabel ||
      //  this.helpersService.getPartnerData().WorkingOnLabel !==
      //  partner.WorkingOnLabel ||
      //  this.helpersService.getPartnerData().WarrantyLabel !==
      //  partner.WarrantyLabel ||
      //  this.helpersService.getPartnerData().WaitingForPartsLabel !==
      //  partner.WaitingForPartsLabel ||
      //  this.helpersService.getPartnerData().WaitingForClientLabel !==
      //  partner.WaitingForClientLabel ||
      //  this.helpersService.getPartnerData().CompletedLabel !==
      //  partner.CompletedLabel ||
      //  this.helpersService.getPartnerData().CollectedLabel !==
      //  partner.CollectedLabel ||
      //  this.helpersService.getPartnerData().DeliveryLabel !==
      //  partner.DeliveryLabel ||
      //  this.helpersService.getPartnerData().CancelledLabel !==
      //  partner.CancelledLabel
      //) {
      //  this.confirmationService.confirm({
      //    rejectVisible: true,
      //    rejectLabel: this.translate.instant('general.no'),
      //    acceptLabel: this.translate.instant('general.yes'),
      //    message: this.translate.instant(
      //      'bikeshop.shop_profile.i_need_help_label_reload',
      //      { INeedHelpLabel: partner.INeedHelpLabel },
      //    ),
      //    accept: () => {
      //      this.helpersService.savePartnerData(partner);
      //      window.location.reload();
      //    },
      //  });
      //  this.helpersService.savePartnerData(partner);
      //} else if (RequestOrder != partner.RequestOrder) {
      //  this.confirmationService.confirm({
      //    rejectVisible: true,
      //    rejectLabel: this.translate.instant('general.no'),
      //    acceptLabel: this.translate.instant('general.yes'),
      //    message: this.translate.instant(
      //      'bikeshop.shop_profile.special_order_reload',
      //    ),
      //    accept: () => {
      //      window.location.reload();
      //    },
      //  });
      //} else if (
      //  this.partner.PrintJobcardQRCode != partner.PrintJobcardQRCode
      //) {
      //  this.confirmationService.confirm({
      //    rejectVisible: true,
      //    rejectLabel: this.translate.instant('general.no'),
      //    acceptLabel: this.translate.instant('general.yes'),
      //    message: this.translate.instant(
      //      'bikeshop.shop_setup.general_reload_question',
      //    ),
      //    accept: () => {
      //      window.location.reload();
      //    },
      //  });
      //} else if (
      //  this.partner.ShowLineItemNotesOnJobcard !=
      //  partner.ShowLineItemNotesOnJobcard
      //) {
      //  this.confirmationService.confirm({
      //    rejectVisible: true,
      //    rejectLabel: this.translate.instant('general.no'),
      //    acceptLabel: this.translate.instant('general.yes'),
      //    message: this.translate.instant(
      //      'bikeshop.shop_setup.general_reload_question',
      //    ),
      //    accept: () => {
      //      window.location.reload();
      //    },
      //  });
      //} else if (
      //  this.partner.ShowJobCardBarcode != partner.ShowJobCardBarcode
      //) {
      //  this.confirmationService.confirm({
      //    rejectVisible: true,
      //    rejectLabel: this.translate.instant('general.no'),
      //    acceptLabel: this.translate.instant('general.yes'),
      //    message: this.translate.instant(
      //      'bikeshop.shop_setup.general_reload_question',
      //    ),
      //    accept: () => {
      //      window.location.reload();
      //    },
      //  });
      //} else if (this.partner.ShowJobCardStatus != partner.ShowJobCardStatus) {
      //  this.confirmationService.confirm({
      //    rejectVisible: true,
      //    rejectLabel: this.translate.instant('general.no'),
      //    acceptLabel: this.translate.instant('general.yes'),
      //    message: this.translate.instant(
      //      'bikeshop.shop_setup.general_reload_question',
      //    ),
      //    accept: () => {
      //      window.location.reload();
      //    },
      //  });
      //}

      this.helpersService.savePartnerData(partner);
      this.confirmationService.confirm({
        rejectVisible: true,
        rejectLabel: this.translate.instant('general.no'),
        acceptLabel: this.translate.instant('general.yes'),
        message: this.translate.instant(
          'bikeshop.shop_setup.general_reload_question',
        ),
        accept: () => {
          window.location.reload();
        },
      })

    });
  }

  toggleDailyGoals(event) {
    if (event.checked) {
      this.ShopForm.controls['ShowLabourTotalsCalendar'].setValue(true);
      this.ShopForm.controls['ShowLabourTotalsCalendar'].disable();
    } else {
      this.ShopForm.controls['ShowLabourTotalsCalendar'].enable();
    }
  }

  setINeedHelpState() {
    if (!this.ShopForm.value.ShowINeedHelp) {
      this.ShopForm.controls['INeedHelpLabel'].disable();
    } else {
      this.ShopForm.controls['INeedHelpLabel'].enable();
    }
  }

  setDailySummaryReportState() {
    if (!this.ShopForm.value.SendDailySummaryReport) {
      this.ShopForm.controls['DailySummaryReportRecipients'].disable();
    } else {
      this.ShopForm.controls['DailySummaryReportRecipients'].enable();
    }
  }

  qrCodeUploader(event) {
    let uploadFile = event.target.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(uploadFile);
    reader.onload = (file: any) => {
      let data = {
        Image: file.target.result,
        Folder: 'partnerphotos',
        Type: 'PrintOutQRImage',
      };
      this.partnerService
        .uploadImage(data, this.partnerId)
        .subscribe((result) => {
          this.ShopForm.value.PrintOutQRImageURL = result;
        });
    };
  }

  // Format hour for display (e.g. 8 → "8:00 AM")
  formatHourForDisplay(hour: number): string {
    var format = 'H:mm';
    if (this.partnerCountry.code == 'US') {
      format = 'h:mm A';
    }

    return moment().hour(hour).minute(0).format(format);
  }


  // Add this property
  activeSection: string = 'workshop-insights';

  // Add this method
  setActiveSection(section: string): void {
    this.activeSection = section;
  }

  // Bay & Tag management
  bays: { id?: number; name: string; editing: boolean; editValue: string; isNew?: boolean }[] = [];
  tags: { id?: number; name: string; editing: boolean; editValue: string; isNew?: boolean }[] = [];

  getBays() {
    this.serviceRequestService.getBays(this.partner.ID).subscribe(res => {
      console.log(res);
      this.bays = [];
      res.forEach(bay => {
        this.bays.push({ id: bay.id, name: bay.bayTag, editing: false, editValue: bay.bayTag, isNew: false });
      });
      this.disableAddBays = false;
    });
  }

  getTags() {
    this.serviceRequestService.getTags(this.partner.ID).subscribe(res => {
      console.log(res);
      this.tags = [];
      res.forEach(tag => {
        this.tags.push({ id: tag.id, name: tag.tag, editing: false, editValue: tag.tag, isNew: false });
      });
      this.disableAddTags = false;
    });
  }

  addBay() {
    this.disableAddBays = true;
    this.bays.push({ id: 0, name: '', editing: true, editValue: '', isNew: true });
  }

  editBay(bay) {
    this.disableAddBays = true;
    bay.editValue = bay.name;
    bay.editing = true;
  }

  saveBay(bay) {
    if (bay.editValue && bay.editValue.trim()) {
      bay.name = bay.editValue.trim();
    }
    console.log(bay);
    if (bay.editValue.trim().length == 0) return;
    if (this.checkUniqueBays(bay.name) == false) return;  
    //if (this.checkUniqueBays(bay.editValue) == false) return;  
    bay.editing = false;
    bay.isNew = false;
    this.serviceRequestService.saveBays(this.partner.ID, { ID: bay.id, PartnerID: this.partner.ID, BayTag: bay.name, IsActive: true }).subscribe(res => { this.getBays(); });
    
  }

  cancelBayEdit(bay, index: number) {
    if (bay.isNew) {
      this.bays.splice(index, 1);
    } else {
      bay.editing = false;
    }
    this.disableAddBays = false;
  }

  //deleteBay(bay, index: number) {
  //  this.bays.splice(index, 1);
  //  console.log(bay);
  //  this.serviceRequestService.deleteBays(this.partner.ID, bay.id).subscribe(res => { this.getBays(); });
  //}

  deleteBay(bay, index: number) {
    this.confirmationService.confirm({
      rejectVisible: true,
      header: this.translate.instant(
        'bikeshop.shop_profile.collections.delete_item',
      ) + ': ' + bay.name,
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.yes'),
      message: this.translate.instant('bikeshop.workshop.jobcard.customer.remove_customer_confirm_header'),
      accept: () => {
        this.bays.splice(index, 1);
        console.log(bay);
        this.serviceRequestService.deleteBays(this.partner.ID, bay.id).subscribe(res => { this.getBays(); });
      },
    });
  }

  addTag() {
    this.disableAddTags = true;
    this.tags.push({ id: 0, name: '', editing: true, editValue: '', isNew: true });
    this.serviceRequestService.saveTags(this.partner.ID, {}).subscribe(res => { });
  }

  editTag(tag) {
    this.disableAddTags = true;
    tag.editValue = tag.name;
    tag.editing = true;
  }

  saveTag(tag) {
    if (tag.editValue && tag.editValue.trim()) {
      tag.name = tag.editValue.trim();
    }
    if (tag.editValue.trim().length == 0) return;
    if (this.checkUniqueTags(tag.name) == false) return;  
    //if (this.checkUniqueTags(tag.editValue) == false) return;  
    tag.editing = false;
    tag.isNew = false;
    this.serviceRequestService.saveTags(this.partner.ID, { ID: tag.id, PartnerID: this.partner.ID, Tag: tag.name, IsActive: true }).subscribe(res => { this.getTags();  });
  }

  cancelTagEdit(tag, index: number) {
    if (tag.isNew) {
      this.tags.splice(index, 1);
    } else {
      tag.editing = false;
    }
    this.disableAddTags = false;
  }

  deleteTag(tag, index: number)
  {
    this.confirmationService.confirm({
      rejectVisible: true,
      header: this.translate.instant(
        'bikeshop.shop_profile.collections.delete_item',
      ) + ': ' + tag.name ,
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.yes'),
      message: this.translate.instant('bikeshop.workshop.jobcard.customer.remove_customer_confirm_header'),
      accept: () => {
        this.tags.splice(index, 1);
        this.serviceRequestService.deleteTags(this.partner.ID, tag.id).subscribe(res => { this.getTags(); });
      },
    });
  } 

  checkUniqueTags(itemToCheck: string): boolean {
    const normalised = itemToCheck.trim().toLowerCase();
    if (!normalised) {
      return true;
    }
    const matches = this.tags.filter(tag =>
      tag.name.trim().toLowerCase() === normalised && tag.id != 0 && tag.editing == false
    );
    return matches.length === 0;
  }

  checkUniqueBays(itemToCheck: string): boolean {
    const normalised = itemToCheck.trim().toLowerCase();
    if (!normalised) {
      return true;
    }
    const matches = this.bays.filter(bay =>
      bay.name.trim().toLowerCase() === normalised && bay.id != 0 && bay.editing == false
    );
    return matches.length === 0;
  }
}
